import React, {useEffect,useState} from 'react';
import $ from 'jquery';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import * as ShipConstants from '../../Global/Constants';
import Modal from "react-bootstrap/Modal";
import { getUserInfo,getOrgId,getImportStatus,setImportStatus } from '../../Utils/UserFunctions';
// import Inputs from '../../../Components/Inputs/Inputs';
import Wrp from '../../hoc/Wrp/Wrp';
import { callPUT } from '../../Utils/ApiUtil';

const ImportSampleData = (props) => {
    // console.log(props)
    const [data,setData] = useState({
        sampleDataModel : false
    })

    const [val,setVal] = useState('');

    useEffect(() => {
        const userInfo = getUserInfo();
        const importstatus = getImportStatus();
        // console.log(userInfo,importstatus)
        if(userInfo) {
            const sampledata_status = userInfo && userInfo.data && userInfo.data.sampledata_status !== null ? userInfo.data.sampledata_status : null;
            if(sampledata_status !== null && sampledata_status !== undefined) {
                if(sampledata_status === 0) {
                    const dataList = {...data}
                    if(!importstatus){
                        dataList['sampleDataModel'] = importstatus ? importstatus : true;
                    }
                    setData(dataList)
                }
            }
        }
    }, []);

    const toggleSampleDataModel = () => {
        const dataList = {...data}
        dataList['sampleDataModel'] = !data.sampleDataModel;
        setData(dataList);
    }

    const sampleDataChangeHandler = (e) => {
        const {name,value} = e.target;
        // const updateState = {...this.state}
        // this.setState(updateState);
    }

    const saveSampleDataHandler = () => {
        props.Loader();
        console.log('saveSampleDataHandler');
        callPUT("organizations/"+getOrgId()+"/import-sampledata/"+val)
        .then(response => {
          setImportStatus(false);    
          props.Loader();
          console.log(response);
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            props.succMessage(responseData.message);
            toggleSampleDataModel();
          }else {
            props.failMessage(responseData.message);
          }
        })
        .catch(err => {
          props.Loader();
          props.failMessage("Error occured");
          console.log(err);
        })
    }

    const onHideHandler = () => {
        console.log('');
    }

    const valueChangeHandler = (e) => {
        const {name,value} = e.target;
        console.log(name,value);
        setVal(value);
    }

    const saveHandler = () => {

    }

	return (
        
		<Modal size="md" show={data.sampleDataModel} onHide={onHideHandler}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> Sample Data Import</h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row justify-content-md-center">
                    <div className="col-12">
                         <div className="form-group mb-0">
                            <label className="form-label d-block"> Data Load Confirmation </label>
                            <div className="selectgroup-pills">
                                <label className="selectgroup-item">
                                    <input type="radio" name="icon-input" value="" className="selectgroup-input" onChange={valueChangeHandler} checked={(val === "") ? true : false}/>
                                    <span className="selectgroup-button"> 
                                        Load Sample Data 
                                    </span>
                                </label>
                                <label className="selectgroup-item">
                                    <input type="radio" name="icon-input" value="1" className="selectgroup-input" onChange={valueChangeHandler} checked={(val === "1") ? true : false}/>
                                    <span className="selectgroup-button"> 
                                        I will Fill My Own Data 
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/*<div className="row">
                    <div className="col">
                        <a href="#" onClick={e=>saveSampleDataHandler('')} className="btn primary_bg mb-4" data-dismiss="modal">Import some sample data</a>
                        
                    </div>
                    <div className="col">
                        <a href="#" onClick={e=>saveSampleDataHandler(1)} className="btn primary_bg" data-dismiss="modal">I will fill my own data.</a>
                        
                    </div>
                </div>*/}


            </Modal.Body>

            <Modal.Footer>
                <div className="ml-md-auto py-2 py-md-0">
                    <button onClick={saveSampleDataHandler} type="button" disabled="" className="btn primary_bg"> Continue </button> 
                </div>
            </Modal.Footer>
		</Modal>
	);
}
const mapStateToProps = state => {
  return {
    authenticated: state
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImportSampleData));